import { GatsbyImage } from "gatsby-plugin-image";
import { offerDetailsSinglePropsFromVinoDataOffer } from "../../transformers/vino-data/offer-details-single"
import { OfferHeroCard } from "../offer-hero/OfferHeroCard";
import styled from "styled-components";
import { Box, Heading, Stack, Text } from "@vinomofo/components";
import { DashIcon } from "@vinomofo/icons";
import { BadgeStack } from "../badge-stack";
import { OfferSellingPoints } from "../offer-hero/OfferSellingPoints";
import { navigate } from "gatsby";

export const ArticleOffer = (data) => {

    const details = offerDetailsSinglePropsFromVinoDataOffer(data.offer)
    const {
        productId,
        endsAt,
        price,
        unitRRP,
        priceDescription,
        shortDescription,
        discountPercentage,
        discountDollarValue,
        discountDisplay,
        region,
        style,
        showPriceDrop,
        showCountdown,
        awards,
        heroImage,
        relativeSizedHeroImage,
        showDiscountBadge,
        showAwardBadges,
        urgencyMessage,
        isSoldOut,
        tagLine,
        subTagLine,
        name,
        roundelsImage,
        bottleShape,
    } = details;
    const offer = data.offer

    const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  gap: 20px;
  position: relative;
  justify-content: space-evenly;

  @media (min-width: 768px) {
    flex-direction: row; /* Change to row layout (left-right) on larger screens */
    align-items: center; /* Align items to the top in row layout */
  }
`;
    const ResponsiveStack = styled(Stack)`
  display: block; // Default to block on larger screens
  width: 350px;
  @media (max-width: 1199px) {
    display: none; // Hide on smaller screens (< 1200px)
  }
`;


    const ImageWrapper = styled.div`
  cursor: pointer;
  height: 100%;
  text-align: center;
  @media (max-width: 998px) {
    height: 100%; 
  }
`;

    const OfferCardWrapper = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 320px;

  @media (max-width: 998px) {
    width: 100%; 
  }
`;

    const StyledGatsbyImage = styled(GatsbyImage)`
  object-fit: contain;
  object-position: bottom center;
  height: 100%;
  max-height: 500px;
  position: relative;
  @media (max-width: 998px) {
    max-height: 380px;
  }
`;
    return <Container>
        {
            !data.offer.isMixed && <ResponsiveStack space={[0, 2, 3]}>
                {tagLine || subTagLine ? (
                    <Stack space={1}>
                        {tagLine && (
                            <Heading
                                as="p"
                                fontSize={["24px", "40px", "48px"]}
                                variant="xl"
                                fontWeight="700"
                            >
                                {tagLine}
                            </Heading>
                        )}
                        {subTagLine && (
                            <Text variant="sm" color="text.heading" fontWeight="500">
                                <Box
                                    display="inline-block"
                                    color="brand"
                                    verticalAlign="middle"
                                    marginRight="4px"
                                    as="span"
                                >
                                    <DashIcon />
                                </Box>
                                {subTagLine}
                            </Text>
                        )}
                    </Stack>
                ) : null}

                {showAwardBadges && awards?.length > 0 ? (
                    <Box
                        display="block"
                        position={["absolute", "relative"]}
                        top="4px"
                    >
                        <BadgeStack
                            badges={awards}
                            limit={5}
                            horizontal={[false, true]}
                            gap={["-10px", "10px", "-20px"]}
                        />
                    </Box>
                ) : null}

                <Box display={["none", "block"]}>
                    <OfferSellingPoints
                        isSpirit={offer?.isSpirit}
                        isAvailable={!isSoldOut}
                    />
                </Box>
            </ResponsiveStack>
        }


        <ImageWrapper onClick={() => navigate(data.offer.route.path)}>
            <StyledGatsbyImage
                image={heroImage}
                alt={name}
                bottleShape={bottleShape}
                objectFit={'contain'}
            />
        </ImageWrapper>

        <OfferCardWrapper onClick={() => navigate(data.offer.route.path)}>
            <OfferHeroCard
                hideStickyTop={true}
                productId={productId}
                shortDescription={shortDescription}
                price={price}
                rrp={unitRRP}
                priceDescription={priceDescription}
                region={region}
                style={style}
                endsAt={endsAt}
                showCountdown={showCountdown}
                showPriceDrop={showPriceDrop}
                urgencyMessage={urgencyMessage}
                isSoldOut={isSoldOut}
                name={name}
                offer={offer}
                hideIconVarietal={true}
            />
        </OfferCardWrapper>
    </Container>

}